/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetSiteSectionsResponseData,
  GetSiteSectionsResponseDataFromJSON,
  GetSiteSectionsResponseDataFromJSONTyped,
  GetSiteSectionsResponseDataToJSON
} from './GetSiteSectionsResponseData'

/**
 *
 * @export
 * @interface CreateSiteSectionResponse
 */
export interface CreateSiteSectionResponse {
  /**
   *
   * @type {number}
   * @memberof CreateSiteSectionResponse
   */
  status?: number
  /**
   *
   * @type {GetSiteSectionsResponseData}
   * @memberof CreateSiteSectionResponse
   */
  data?: GetSiteSectionsResponseData
}

export function CreateSiteSectionResponseFromJSON(json: any): CreateSiteSectionResponse {
  return CreateSiteSectionResponseFromJSONTyped(json, false)
}

export function CreateSiteSectionResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateSiteSectionResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetSiteSectionsResponseDataFromJSON(json['data'])
  }
}

export function CreateSiteSectionResponseToJSON(value?: CreateSiteSectionResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetSiteSectionsResponseDataToJSON(value.data)
  }
}
